import apiRequest from './handler';

const PayoutService = {
    getPotentialEarnings: async (setIsAuthenticated, navigate) => {
        try {
            const response = apiRequest(
                `/reseller/potential-earnings`,
                'get',
                {},
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching enquiry options:', error);
            throw error;
        }
    }
};

export default PayoutService;
